export default __webpack_public_path__ + "static/media/verif-new.fe1a3f95.png";